import { useState, useEffect } from 'react';

/**
 * Custom hook to detect if the current device is mobile
 * @param {number} breakpoint - The width threshold in pixels to consider a device as mobile (default: 768)
 * @returns {boolean} - Returns true if device is mobile, false otherwise
 */
const useIsMobile = (breakpoint = 768) => {
  // Read the width on first render so consumers that use the value right away
  // (initial state, first paint) don't start in desktop mode and flip after mount
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.innerWidth < breakpoint
  );

  useEffect(() => {
    // Check if window is defined (to avoid SSR issues)
    if (typeof window === 'undefined') {
      return;
    }

    // Function to check if device is mobile based on screen width
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };

    // Initial check
    checkIsMobile();

    // Add event listener for window resize
    window.addEventListener('resize', checkIsMobile);

    // Cleanup function to remove event listener
    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, [breakpoint]);

  return isMobile;
};

export default useIsMobile;
